module.exports = __webpack_public_path__ + "static/Hero-banner-mobile-76c183e259e6b206973bcbfabb3d483d.png";